import type {Editor} from 'grapesjs';
import {closeEmbeddedEditor, closeEmbeddedEditorWithoutCallback, EmbeddedEditorMessageType} from '@Libraries/embedded-editor';
import {SaveActionType, SaveType} from '@FormMakerReact/lib/form-maker-storage-library';
import type {StoreOpts} from '@FormMakerReact/grapesjs-form-maker-plugin/src/form-maker-storage';
import {STORE_OPTS_MODEL_KEY} from '@FormMakerReact/grapesjs-form-maker-plugin/src/form-maker-storage';

export function closeEmbeddedFormEditor(isSilentClose: boolean): void {
  if (isSilentClose) {
    closeEmbeddedEditorWithoutCallback();
  } else {
    closeEmbeddedEditor();
  }
}

export async function saveAndCloseEmbeddedFormEditor(editor: Editor): Promise<void> {
  const opts = editor.getModel().get(STORE_OPTS_MODEL_KEY) as StoreOpts | undefined;
  const idEmailSignupForm = opts?.idEmailSignupForm ?? '';

  try {
    await editor.store({...opts, saveActionType: SaveActionType.FORCE, saveType: SaveType.HARD});
  } catch (e) {
    window.PMW.log('save failed for embedded form editor', e);
    return;
  }

  postSaveMessageToParent(idEmailSignupForm);
  closeEmbeddedFormEditor(true);
}

function postSaveMessageToParent(idEmailSignupForm: string): void {
  window.parent.postMessage(`${EmbeddedEditorMessageType.SAVE}~${idEmailSignupForm}`, '*');
}
